import { render, staticRenderFns } from "./look.vue?vue&type=template&id=17704fbb&scoped=true"
import script from "./look.vue?vue&type=script&lang=js"
export * from "./look.vue?vue&type=script&lang=js"
import style0 from "./look.vue?vue&type=style&index=0&id=17704fbb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17704fbb",
  null
  
)

export default component.exports